import React from "react";
import MetaTags from 'react-meta-tags';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { RowInput, TextField, Breadcrumb, TextEditor} from '../../components/Common'
import { useDispatch, useSelector } from "react-redux"
import { guideCreate as guideCreateRedux } from "../../store/actions"
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Button
} from "reactstrap";

const GuideCreate = props => {
    const dispatch = useDispatch()
    const { apk_name } = useSelector(state => ({
        apk_name: state.Layout.apk_name,
    }))

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Tambah Panduan Kerja | {apk_name}</title>
                </MetaTags>

                <Formik
                    initialValues={{
                        name: '',
                        description: '',
                    }}
                    validationSchema={Yup.object().shape({
                        name: Yup.string().required('Judul tidak boleh kosong'),
                    })}

                    onSubmit={(values, { setSubmitting }) => dispatch(guideCreateRedux(values, setSubmitting, props.history))}

                    render={({ values, errors, touched, isSubmitting }) => {

                        return (
                            <>
                                <Form>
                                    <Container fluid={true}>
                                        <Breadcrumb title="Tambah Panduan Kerja" breadcrumbItems={[
                                            { title: 'Dashboard', link: '/dashboard' },
                                            { title: 'Panduan Kerja', link: '/panduan_kerja' },
                                            { title: 'Tambah', link: `/panduan_kerja/tambah` }
                                        ]} />
                                        <Row>
                                            <Col lg={10}>
                                                <Card>
                                                    <CardBody>
                                                        <CardTitle className="mb-4"></CardTitle>
                                                        <RowInput
                                                            label="Judul"
                                                            mandatory={true}
                                                            labelSize={2}
                                                            size={9}
                                                        >
                                                            <TextField
                                                                name="name"
                                                                type="text"
                                                                errors={errors.name}
                                                                touched={touched.name}
                                                            />
                                                        </RowInput>
                                                        <RowInput
                                                            label="Deskripsi"
                                                            labelSize={2}
                                                            size={9}
                                                        >
                                                            <TextEditor
                                                                name="description"
                                                                errors={errors.description}
                                                                touched={touched.description}
                                                            />
                                                        </RowInput>

                                                        <hr></hr>
                                                        <Row className="justify-content-end">
                                                            <Col lg="12">
                                                                <Button type="submit" color="primary" disabled={isSubmitting}>
                                                                    <i className="bx bx-save font-size-16 align-middle me-2"></i>
                                                                    {isSubmitting ? 'Loading...' : 'Simpan'}
                                                                </Button>
                                                                &nbsp;
                                                                <Button type="button" color="secondary" onClick={() => { props.history.push('/panduan_kerja') }}>
                                                                    <i className="bx  bx-left-arrow-circle font-size-16 align-middle me-2"></i>
                                                                    {'Kembali'}
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Form>
                            </>
                        )
                    }}
                />
            </div>
        </React.Fragment>
    );
};



export default GuideCreate;
